var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMoreItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 12.5,
    r: 9.75,
    fill: "white",
    stroke: "#26A62B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.248 11.768V13.511H11.594V17.165H9.851V13.511H6.218V11.768H9.851V8.135H11.594V11.768H15.248Z",
    fill: "#26A62B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoreItem);
export default __webpack_public_path__ + "static/media/AddMoreItem.6fc2833303b7fdc869a16c9a5d563eab.svg";
export { ForwardRef as ReactComponent };